import { Box } from '@chakra-ui/react';
import * as React from 'react';

import { useGetAbsoluteUrl } from '@/imports/ui/hooks/useGetAbsoluteUrl';

import { InteractionPage_currentOidcInteraction_currentOidcInteraction } from '../../graphql-types/InteractionPage_currentOidcInteraction';
import { HandleConsent, HandleLogin } from './components';

export const InteractionPageContent: React.FC<{
  data: InteractionPage_currentOidcInteraction_currentOidcInteraction;
}> = ({ data }) => {
  const { getAbsoluteUrl } = useGetAbsoluteUrl(false);

  if (!getAbsoluteUrl) {
    return null;
  }

  return (
    <Box h="100vh">
      <Box maxW="md" mx="auto" px="4" mt={16}>
        {data.result?.interaction.prompt.name === 'login' ? (
          <HandleLogin
            formAction={getAbsoluteUrl(`oidc${window.location.pathname}/login`)}
          />
        ) : (
          <HandleConsent
            formAction={getAbsoluteUrl(
              `oidc${window.location.pathname}/confirm`
            )}
          />
        )}
      </Box>
    </Box>
  );
};
